import { Typography } from '@/components';
import { TextStyles } from '@/constants';
import type { CSSProperties } from 'react';
import styled from 'styled-components';

const ellipsis: CSSProperties = {
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
};

const multiEllipsis: CSSProperties = {
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
};

export const Title = styled(Typography).attrs({
  variant: TextStyles['Heading 5'],
})(({ theme }) => ({
  ...multiEllipsis,
  WebkitLineClamp: 3,
  color: theme.colors.mediumEmphasisBlack,
  marginBottom: theme.spacing[4],
}));

export const Time = styled(Typography).attrs({
  variant: TextStyles['Caption Text'],
})(({ theme }) => ({
  ...ellipsis,
  color: theme.colors.mediumEmphasisBlack,
}));

export const MerchantName = styled(Typography).attrs({
  variant: TextStyles['Caption Text'],
})(({ theme }) => ({
  ...ellipsis,
  color: theme.colors.mediumEmphasisBlack,
  textTransform: 'uppercase',
}));

export const Dot = styled.div(({ theme }) => ({
  flexShrink: 0,
  // flexGrow: 0,
  display: 'inline-block',
  width: theme.spacing[4],
  height: theme.spacing[4],
  borderRadius: '50%',
  backgroundColor: '#D9D9D9',
}));

export const DateTimeWrapper = styled.div(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing[4],

  '> :last-child': {
    minWidth: '50%',
  },
}));
